import { render, staticRenderFns } from "./tixian02_list.vue?vue&type=template&id=3ca5a970&scoped=true"
import script from "./tixian02_list.vue?vue&type=script&lang=js"
export * from "./tixian02_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5a970",
  null
  
)

export default component.exports